import React, { useState } from "react";
import { ImageURLGenerator } from "../../../SketchUtilities/ImageURLGenerator";

interface Props {
  image: string;
  index: number;
  isSelected: boolean;
  handleSelect: (image: string, index: number) => void;
}

export const GalleryImage = (props: Props) => {
  const [classname, setClassname] = useState<string>("inactiveImage");
  return (
    <div
      key={props.image}
      className={`${classname} ${props.isSelected}`}
      onMouseEnter={() => {
        setClassname("activeImage");
      }}
      onMouseLeave={() => {
        setClassname("inactiveImage");
      }}
      onClick={( e ) => {
        props.handleSelect(props.image, 
          props.index);
      }}
      style={{
        border: props.isSelected ? "4px solid black" : "",
        display: "inline-flex",
        width: "70px",
        margin: "10px",
        height: "auto",
      }}
    >
      <img
        alt=""
        src={ImageURLGenerator(props.image, "sm")}
        style={{ maxWidth: "100%" }}
      />
    </div>
  );
};
